<template>
  <div id="system-management-team-add">
    <ipub-model :title="params.id?'Edit Management Team':'Add a New Team Member'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="management-team-add-form"
                 :model="params"
                 :rules="rules">
        <div class="flex">
          <div style="width:85%">
            <ipub-row :gutter="20">
              <ipub-col :span="4">
                <ipub-form-item prop="titleCode"
                                label="Title">
                  <ipub-select v-model="params.titleCode"
                               placeholder="Enter Title">
                    <ipub-select-option v-for="(value) in titleList"
                                        v-show="value.enabled"
                                        :key="value.id"
                                        :value="value.code">
                      {{value.name}}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="firstName"
                                label="First Name">
                  <ipub-input placeholder="Enter first name"
                              v-model.trim="params.firstName" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="lastName"
                                label="Last Name">
                  <ipub-input placeholder="Enter last name"
                              v-model.trim="params.lastName" />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="20">
              <ipub-col :span="5">
                <ipub-form-item prop="email"
                                label="Email">
                  <ipub-input placeholder="Enter frequency used email"
                              v-model.trim="params.email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="2"
                        class="flex-center">
                <ipub-radio :checked="params.displayEmail"
                            @change="params.displayEmail=!params.displayEmail">
                  <div>
                    Show Email
                  </div>
                </ipub-radio>
              </ipub-col>
              <ipub-col :span="5">
                <ipub-form-item prop="identityCode"
                                label="Select role">
                  <ipub-select v-model="params.identityCode"
                               placeholder="Role">
                    <ipub-select-option v-for="(value) in managementTeamList"
                                        v-show="value.enabled"
                                        :key="value.id"
                                        :value="value.code">
                      {{value.name}}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>

            </ipub-row>
          </div>
          <div class="mar-l-20 relative"
               style="width:15%">
            <ipub-form-item prop="icon">
              <div class="upload-content right-option">
                <div class="upload-content-img">
                  <ipub-upload-cropper @change="handleUpload"
                                       :canWidth="105"
                                       :canHeight="130"
                                       :scales="2"
                                       :imgUrl="params.icon?domain+'/'+params.icon:domain+'/imageFile/icon.svg'" />
                </div>
              </div>
            </ipub-form-item>
          </div>
        </div>
        <ipub-form-item prop="linked"
                        label="Links">
          <ipub-radio-group class="mar-b-10"
                            v-model="params.linked"
                            @change="onLinkedChange"
                            _label="name"
                            :options="[{name:'Yes',value:true},{name:'No',value:false}]" />
          <ipub-input v-if="params.linked"
                      placeholder="Enter URL here"
                      v-model.trim="params.linkAddress" />
          <!-- <ipub-editor v-else
                       :height="200"
                       v-model.trim="params.linkText" /> -->
        </ipub-form-item>
        <ipub-form-item prop="info"
                        label="Introduction">
          <ipub-editor :height="300"
                       placeholder="Enter introduction of team member here"
                       v-model="params.info" />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="cancel">Cancel</ipub-button>
        <ipub-button type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(false)">Save as Draft</ipub-button>
        <ipub-button v-if="!params.id"
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(true)">Publish</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '../../../../utils/upload'
import team from '../../../../api/team'
import check from '../../../../utils/check'
import { settingOption } from '@/api/setting'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      params: {
        linked: true,
        displayEmail: false
      },
      rules: {},
      roles: [],
      managementTeamList: [],
      titleList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
      managementTeam: 'getManagementTeam',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          linked: true,
          displayEmail: false
        }
      }
    }
  },
  mounted () {
    this.getRules()
    this.getData()
  },
  methods: {
    async getQuery (id) {
      this.params = await team.query(id)
    },
    async getData () {
      const titleList = await settingOption.get({ type: 'TITLE' })
      const managementTeamList = await settingOption.get({ type: 'MANAGEMENT_TEAM_ROLE' })
      this.titleList = titleList
      this.managementTeamList = managementTeamList
    },
    async handleUpload (files) {
      const file = files[0]
      const types = ['image/jpeg', 'image/png']
      const rightType = types.includes(file.type)
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/management-team`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, 'iconName', file.name)
      this.$set(this.params, 'icon', url)
    },
    async confirm (val) {
      if (this.params.linked) {
        if (!this.params.linkAddress || !check.website(this.params.linkAddress)) {
          this.$message.error({ title: 'Error', content: this.LANGUAGE[this.language].enterCorrent + 'Link' })
          return
        }
      }
      const flag = this.$refs['management-team-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          released: val || this.params.released || false
        })
        if (this.params.id) {
          await team.edit(this.params.id, data)
          this.$message.success({ title: 'Success', content: 'This Management Team has been published!' })
        } else {
          await team.add(data)
          if (val) {
            this.$message.success({ title: 'Success', content: 'This Management Team has been published!' })
          } else {
            this.$message.success({ title: 'Success', content: 'This Management Team has been saved!' })
          }
        }
        this.$emit('confirm', data)
      }
    },
    onLinkedChange () {
      this.params.linkAddress = ''
      this.params.linkText = ''
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        titleCode: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        firstName: [
          {
            required: true,
            message:
              'First Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message:
              'Last Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        identityCode: [
          {
            required: true,
            message:
              'Role' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        email: [
          {
            required: true,
            message:
              'Email' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message:
              this.LANGUAGE[this.language].enterCorrent +
              'Email'
          }
        ],
        linked: [
          {
            required: true,
            message:
              'Link' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        info: [
          {
            required: true,
            message:
              'Introduction' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#system-management-team-add {
  .upload-content {
    margin-top: 30px;
    &-img {
      border-radius: 4px;
      height: 140px;
      width: 125px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
